
import { Lesson, SourceBook } from "../types";

export async function generateDailyLesson(
  lang: 'fr' | 'en',
  existingLessonTitles: string[] = [],
  preferredSource?: SourceBook,
  lastLessonDate?: string
): Promise<Lesson> {
  // Check if a lesson was already generated today
  if (lastLessonDate) {
    const last = new Date(lastLessonDate);
    const now = new Date();
    if (last.toDateString() === now.toDateString()) {
      throw new Error("ALREADY_GENERATED_TODAY");
    }
  }

  const response = await fetch('/api/generateDailyLesson', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ lang, existingLessonTitles, preferredSource }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Erreur serveur' }));
    throw new Error(err.error);
  }

  const raw = await response.json();
  return {
    ...raw,
    id: crypto.randomUUID(),
    date: new Date().toISOString(),
    isFavorite: false,
    notes: ""
  };
}
